import Alpine from 'alpinejs';
import { ReportModal } from './report_modal';

Alpine.data('reportModal', () => new ReportModal());
